import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import Input_controller from './input controller';

// Usage:
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//

var ReactInput = function (_React$Component) {
	_inherits(ReactInput, _React$Component);

	function ReactInput(props) {
		_classCallCheck(this, ReactInput);

		var _this = _possibleConstructorReturn(this, (ReactInput.__proto__ || _Object$getPrototypeOf(ReactInput)).call(this, props));

		_this.store_instance = function (instance) {
			_this.input = instance;
		};

		_this.get_input_element = function () {
			return ReactDOM.findDOMNode(_this.input);
		};

		_this.on_blur = function (event) {
			var onBlur = _this.props.onBlur;

			// This `onBlur` interceptor is a workaround for `redux-form`,
			// so that it gets the right (parsed, not the formatted one)
			// `event.target.value` in its `onBlur` handler.

			if (onBlur) {
				var _event = _extends({}, event, {
					target: _extends({}, event.target, {
						value: _this.input_controller.getParsedValue().value
					})
				});

				// For `redux-form` event detection.
				// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
				_event.stopPropagation = event.stopPropagation;
				_event.preventDefault = event.preventDefault;

				onBlur(_event);
			}
		};

		_this.on_key_down = function (event) {
			var onKeyDown = _this.props.onKeyDown;


			if (onKeyDown) {
				onKeyDown(event);
			}

			_this.input_controller.onKeyDown(event);
		};

		var _this$props = _this.props,
		    parse = _this$props.parse,
		    format = _this$props.format,
		    onChange = _this$props.onChange;


		_this.input_controller = new Input_controller(_this.get_input_element, parse, format, onChange);
		return _this;
	}

	_createClass(ReactInput, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    value = _props.value,
			    parse = _props.parse,
			    format = _props.format,
			    inputComponent = _props.inputComponent,
			    rest = _objectWithoutProperties(_props, ['value', 'parse', 'format', 'inputComponent']);

			// Non-string `inputComponent`s would work in this case
			// but it would also introduce a caret reset bug:
			// the caret position would reset on each input.
			// The origins of this bug are unknown, they may be
			// somehow related to the `ref` property
			// being intercepted by React here.


			return React.createElement(inputComponent, _extends({}, rest, {
				ref: this.store_instance,
				value: format(is_empty(value) ? '' : value).text,
				onKeyDown: this.on_key_down,
				onChange: this.input_controller.onChange,
				onPaste: this.input_controller.onPaste,
				onCut: this.input_controller.onCut,
				onBlur: this.on_blur
			}));
		}

		// Returns <input/> DOM Element


		// This handler is a workaround for `redux-form`

	}, {
		key: 'focus',
		value: function focus() {
			this.get_input_element().focus();
		}
	}]);

	return ReactInput;
}(React.Component);

ReactInput.propTypes = {
	// Parses a single characher of `<input/>` text
	parse: PropTypes.func.isRequired,

	// Formats `value` into `<input/>` text
	format: PropTypes.func.isRequired,

	// Renders `<input/>` by default
	inputComponent: PropTypes.string.isRequired,

	// `<input/>` `type` attribute
	type: PropTypes.string.isRequired,

	// Is parsed from <input/> text
	value: PropTypes.string,

	// This handler is called each time `<input/>` text is changed
	onChange: PropTypes.func.isRequired,

	// This `onBlur` interceptor is a workaround for `redux-form`,
	// so that it gets the parsed `value` in its `onBlur` handler,
	// not the formatted text.
	onBlur: PropTypes.func,

	// Passthrough
	onKeyDown: PropTypes.func
};
ReactInput.defaultProps = {
	// Renders `<input/>` by default
	inputComponent: 'input',

	// `<input/>` `type` attribute
	type: 'text'
};
export default ReactInput;


function is_empty(value) {
	return value === undefined || value === null;
}
//# sourceMappingURL=react input.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/~/input-format/es6/react input.js
// module id = ./node_modules/react-phone-number-input/node_modules/input-format/es6/react input.js
// module chunks = 0 1 2